import React, { useEffect, useRef } from 'react';
import { config } from '@/config';

interface MicrofrontendViewerProps {
  url: string;
}

const normalizeOrigin = (url: string) => {
  try {
    return new URL(url).origin; // normalize origin (protocol + domain)
  } catch {
    return '';
  }
};

const MicrofrontendViewer: React.FC<MicrofrontendViewerProps> = ({ url }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const iframeOrigin = normalizeOrigin(url);

/** DO NOT ADD CONSOLE LOGS inside handleMessage function */
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== iframeOrigin) {
        return;
      }

      if (event.data?.type === 'REQUEST_ENVIRONMENT_CONFIG') {
        const iframe = iframeRef.current;
        iframe?.contentWindow?.postMessage(
          { data: config, type: 'ENVIRONMENT_CONFIG' },
          iframeOrigin
        );
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [iframeOrigin]);

/** DO NOT ADD CONSOLE LOGS inside handleMessage function */

  const handleLoad = () => {
    console.log('Viewer - Iframe loaded:', url);
  };

  return (
    <div className="w-full h-full">
      <iframe
        ref={iframeRef}
        src={url}
        className="w-full h-full border-0 min-h-content"
        title="Microfrontend"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-modals"
        onLoad={handleLoad}
        style={{ minHeight: 'calc(100vh - 135px)', width: '100%' }}
      />
    </div>
  );
};

export default MicrofrontendViewer;